import { Helmet } from 'react-helmet-async';

const MetaTags = ({ 
  title, 
  description, 
  image, 
  url,
  type = 'article',
  keywords = [],
  author = 'Parenting Beyond Perfection',
  publishedTime,
  modifiedTime,
  canonicalUrl
}) => {
  const siteName = 'Parenting Beyond Perfection';
  const defaultImage = `${window.location.origin}/logo.png`; // Your default site image
  const defaultKeywords = ['parenting tips', 'parenting advice', 'family life', 'child development', 'positive parenting'];

  return (
    <Helmet>
      {/* Basic meta tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={[...defaultKeywords, ...keywords].join(', ')} />
      <meta name="author" content={author} />
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}

      {/* Open Graph meta tags (Facebook, LinkedIn, etc) */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image || defaultImage} />
      <meta property="og:url" content={url || window.location.href} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={siteName} />
      {publishedTime && <meta property="article:published_time" content={publishedTime} />}
      {modifiedTime && <meta property="article:modified_time" content={modifiedTime} />}

      {/* Twitter Card meta tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image || defaultImage} />

      {/* Additional SEO tags */}
      <meta name="robots" content="index, follow" />
      <meta name="googlebot" content="index, follow" />
      <meta name="language" content="English" />
    </Helmet>
  );
};

export default MetaTags; 